import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import SalesCatalystChart from '../SalesCatalystCharts/SalesCatalystChart';
import {
  NO_DATA_AVAILABLE_MSG,
  CLICK_RUN_REPORT_MSG,
  SALES_CATALYST_BRAND_REQUIRED_CHART_MSG,
  SC_INVALID_COMBINATION_MSG,
} from '../../../messages/messages';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import {
  SALES_CATALYST_DATA_SELECTION, SALES_CATALYST_DATA_SUBENTITIES,
} from '../../../constants';

class SalesCatalystMediaPackageBarChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scTargetEntityBrandSubEntities: this.props.graphData.scTargetEntityBrand.subEntities !== undefined ? this.props.graphData.scTargetEntityBrand.subEntities : [],
      scTargetBrandSubEntities: this.props.graphData.scTargetBrand.subEntities !== undefined ? this.props.graphData.scTarget.subEntities : [],
    };
  }

  getChartInfo = (slideName, type) => {
    const { graphData, dataSelection } = this.props;

    let barChartData = {};
    let barChartMsg = NO_DATA_AVAILABLE_MSG;

    switch (slideName) {
      case 0:
        barChartData = graphData.scTarget;
        break;
      case 1:
        barChartData = graphData.scTargetEntity;
        break;
      case 2:
        barChartData = graphData.scTargetEntityBrand;
        barChartMsg = this.getBarChartMsg(graphData.scTargetEntityBrand, dataSelection.brand, this.state.scTargetEntityBrandSubEntities);
        break;
      case 3:
        barChartData = graphData.scTargetBrand;
        barChartMsg = this.getBarChartMsg(graphData.scTargetBrand, dataSelection.brand, this.state.scTargetBrandSubEntities);
        break;
      default:
        barChartData = {};
    }
    return type !== 'msg' ? barChartData : barChartMsg;
  }

  getBarChartMsg = (graphData, brand, SubEntities) => {
    let barChartMsg = '';
    if (_.isEmpty(graphData)) {
      barChartMsg = _.isEmpty(brand) ?
        SALES_CATALYST_BRAND_REQUIRED_CHART_MSG : CLICK_RUN_REPORT_MSG;
    }
    if ((!_.isEmpty(graphData)) && (SubEntities.length === 0)) {
      _.forEach(graphData.headers, headerInfo => {
        if (headerInfo.sample === 0) {
          barChartMsg = SC_INVALID_COMBINATION_MSG;
          return false;
        } else {
          barChartMsg = NO_DATA_AVAILABLE_MSG;
        }
      });
    }
    return barChartMsg;
  }

  setChartSortInfo = sortInfo => {
    this.props.salesCatalystActions.setChartSortInfo(sortInfo);
  }

  editSubEntitiesFn = response => {
    const headerInfo = _.map(response, o => {
      return {
        defId: null,
        expId: null,
        expression: o.expression,
        label: o.label,
        sample: undefined,
        weighted: undefined,
      };
    });

    this.props.salesCatalystActions.addSalesCatalystDataPoints(
      headerInfo,
      SALES_CATALYST_DATA_SELECTION,
      _.camelCase(SALES_CATALYST_DATA_SUBENTITIES),
    );
    this.props.salesCatalystActions.showCofigurationScreen(true);
    /* this.props.salesCatalystActions.setCofigurationPackageData(
      undefined,
      SC_SELECTED_SUBENTITY_LIST
    );
    this.props.salesCatalystActions.setCofigurationPackageData(
      false,
      SC_IS_SUBENTITY_LIST_UPDATED
    ); */
  }

  render() {
    const { slideOrder, universityUser } = this.props;
    return (
      <div>
        <SalesCatalystChart
          data={this.getChartInfo(slideOrder)}
          message={this.getChartInfo(slideOrder, 'msg')}
          sortFn={this.setChartSortInfo}
          sortInfo={this.props.chartSortInfo}
          editSubEntitiesFn={this.editSubEntitiesFn}
          universityUser={universityUser}
          studyInfo={this.props.studyInfo}
        />
      </div>
    );
  }
}

SalesCatalystMediaPackageBarChart.propTypes = {
  graphData: PropTypes.shape({}),
  slideOrder: PropTypes.number,
  universityUser: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    dataSelection: state.salesCatalyst.dataSelection,
    dataOnScreenTarget: state.salesCatalyst.dataOnScreen.targetMarket,
    graphData: state.salesCatalyst.graphData,
    chartSortInfo: state.salesCatalyst.chartSortInfo,
    universityUser: state.login.loginResponse.data.universityUser || false,
    studyInfo: state.study.salesCatalystStudy
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(SalesCatalystMediaPackageBarChart);
